<form class="g-3 needs-validation" novalidate [formGroup]="formFields" (ngSubmit)="onSubmit()">
  <!-- Additional Horse Details Section -->
  <div class="form_sections">
    <h4><u>Additional Horse Details</u></h4>
    
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Height of Horse (Hands) <span class="text-danger">*</span></label>
          <mat-select
            formControlName="height"
            class="form-control form-control-sm w-100"
            name="height"
            required
            [ngClass]="{
              'is-invalid':
                (f.height.touched || submitted) &&
                f.height.errors?.required
            }"
          >
            <mat-option [value]="">Select Height</mat-option>
            <mat-option *ngFor="let height of heights" [value]="height">
              {{ height }}
            </mat-option>
          </mat-select>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.height.touched || submitted) &&
              f.height.errors?.required
            "
          >
            Height of Horse is required.
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Breed of Horse <span class="text-danger">*</span></label>
          <input
            type="text"
            matInput
            formControlName="breed_id"
            [matAutocomplete]="breedAuto"
            placeholder="Start typing to search..."
            class="form-control form-control-sm"
            required
            [ngClass]="{
              'is-invalid':
                (f.breed_id.touched || submitted) &&
                f.breed_id.errors?.required
            }"
          />
          <mat-autocomplete #breedAuto="matAutocomplete" [displayWith]="displayBreed">
            <mat-option
              *ngFor="let breed of filteredBreeds | async"
              [value]="breed"
            >
              {{ breed.breed }}
            </mat-option>
          </mat-autocomplete>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.breed_id.touched || submitted) &&
              f.breed_id.errors?.required
            "
          >
            Breed of Horse is required.
          </div>
          <small class="form-text text-white">If the horse is a mixed breed, then please select the most applicable option</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Colour of Horse <span class="text-danger">*</span></label>
          <input
            type="text"
            matInput
            formControlName="color_id"
            [matAutocomplete]="colorAuto"
            placeholder="Start typing to search..."
            class="form-control form-control-sm"
            required
            [ngClass]="{
              'is-invalid':
                (f.color_id.touched || submitted) &&
                f.color_id.errors?.required
            }"
          />
            <mat-autocomplete #colorAuto="matAutocomplete" [displayWith]="displayColor">
              <mat-option
                *ngFor="let color of filteredColors | async"
                [value]="color"
              >
                {{ color.color || color.name || color.label || color.value }}
              </mat-option>
            </mat-autocomplete>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.color_id.touched || submitted) &&
              f.color_id.errors?.required
            "
          >
            Colour of Horse is required.
          </div>
          <small class="form-text text-white">Please select the closest option</small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Sex of Horse <span class="text-danger">*</span></label>
          <mat-select
            formControlName="sex_id"
            class="form-control form-control-sm w-100"
            name="sex_id"
            required
            [ngClass]="{
              'is-invalid':
                (f.sex_id.touched || submitted) &&
                f.sex_id.errors?.required
            }"
          >
            <mat-option [value]="">Select Sex</mat-option>
            <mat-option *ngFor="let sex of sexes" [value]="sex.id">
              {{ sex.title }}
            </mat-option>
          </mat-select>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.sex_id.touched || submitted) &&
              f.sex_id.errors?.required
            "
          >
            Sex of Horse is required.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Horse Passport Number</label>
          <input
            type="text"
            name="passport_number"
            formControlName="passport_number"
            placeholder="Passport Number"
            class="form-control form-control-sm"
          />
          <small class="form-text text-white">If not known, please leave blank (do not enter TBC)</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Have you ever had the horse vetted? <span class="text-danger">*</span></label>
          <mat-select
            formControlName="is_horse_vetted"
            class="form-control form-control-sm w-100"
            name="is_horse_vetted"
            [ngClass]="{
              'is-invalid':
                (f.is_horse_vetted.touched || submitted) &&
                f.is_horse_vetted.errors?.required
            }"
          >
            <mat-option [value]="null">Select</mat-option>
            <mat-option [value]="2">Yes</mat-option>
            <mat-option [value]="1">No</mat-option>
          </mat-select>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.is_horse_vetted.touched || submitted) &&
              f.is_horse_vetted.errors?.required
            "
          >
            This field is required.
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="isYesSelection(formFields.get('is_horse_vetted').value)">
        <div class="form-group">
          <label>Date of Vetting <span class="text-danger">*</span></label><br />
          <input
            type="text"
            required
            name="date_of_vetting"
            formControlName="date_of_vetting"
            placeholder="DD/MM/YYYY"
            class="form-control form-control-sm datepicker"
            matInput
            (focus)="vettingDateDatepicker.open()"
            [matDatepicker]="vettingDateDatepicker"
            [max]="maxVettingDate"
            [ngClass]="{
              'is-invalid':
                (f.date_of_vetting.touched || submitted) &&
                f.date_of_vetting.errors?.required
            }"
          />
          <mat-datepicker-toggle [for]="vettingDateDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #vettingDateDatepicker></mat-datepicker>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.date_of_vetting.touched || submitted) &&
              f.date_of_vetting.errors?.required
            "
          >
            Date of Vetting is required.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Is the horse currently insured by you? <span class="text-danger">*</span></label>
          <mat-select
            formControlName="is_currently_insured"
            class="form-control form-control-sm w-100"
            name="is_currently_insured"
            [ngClass]="{
              'is-invalid':
                (f.is_currently_insured.touched || submitted) &&
                f.is_currently_insured.errors?.required
            }"
          >
            <mat-option [value]="null">Select</mat-option>
            <mat-option [value]="2">Yes</mat-option>
            <mat-option [value]="1">No</mat-option>
          </mat-select>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.is_currently_insured.touched || submitted) &&
              f.is_currently_insured.errors?.required
            "
          >
            This field is required.
          </div>
          <small class="form-text text-white">You should only answer 'yes' if the horse will still be insured at the requested start date of this insurance cover, and the current insurance is for a similar type of cover to that being requested i.e. if you have requested cover for mortality and full cover vet's fees and your current insurance is also for mortality and full cover vet's fees</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="row mt-4">
    <div class="col-md-12 d-flex justify-content-between align-items-center">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="GoToPrevTab.emit()">Back</button>
      <div>
        <!-- <button type="button" class="btn btn-outline-secondary btn-sm mr-2" (click)="onSubmit(false)">Save Indicative Quote</button> -->
        <button [disabled]="saving" type="submit" class="btn btn-success btn-sm">Save & Continue</button>
      </div>
    </div>
  </div>
</form>
